export default __webpack_public_path__ + "static/media/10.2bf5c40e.gif";